import { type Environment } from 'relay-runtime';
import { graphql } from 'react-relay/legacy';
import commitMutation from 'relay-commit-mutation-promise';

import {
    type ModifySocialNetworkConnectionInput,
    type modifyEthereumWalletConnectionMutation as MutationType,
    type modifyEthereumWalletConnectionMutation$data,
} from './__generated__/modifyEthereumWalletConnectionMutation.graphql';

const mutation = graphql`
    mutation modifyEthereumWalletConnectionMutation($input: ModifySocialNetworkConnectionInput!) {
        modifySocialNetworkConnection(input: $input) {
            removedId
            bidderRoleTransactionHash
            failureReason
            user {
                serviceId
                ethereumWalletAddress {
                    address
                }
                socialNetworkByName(socialNetworkName: ETHEREUM) {
                    ... on EthereumSocialConnection {
                        serviceId
                        userPreferences {
                            accessToken
                            zipCode
                        }
                    }
                }
            }
        }
    }
`;

type MutationInput = ModifySocialNetworkConnectionInput & { isInternationalCustomer?: boolean };

export function modifyEthereumWalletConnection(
    environment: Environment,
    {
        userId,
        action,
        address,
        accessToken,
        signature,
        message,
        userSocialNetworkId,
        socialNetworkName = 'ETHEREUM',
        zipCode,
        isInternationalCustomer,
    }: MutationInput
): Promise<modifyEthereumWalletConnectionMutation$data> {
    let input;

    if (action === 'DISCONNECT') {
        input = {
            userId,
            action,
            userSocialNetworkId,
        };
    } else if (action === 'CONNECT') {
        input = {
            userId,
            action,
            accessToken,
            socialNetworkName,
            address,
            signature,
            message,
            zipCode: isInternationalCustomer ? 'INTL' : zipCode,
        };
    } else {
        input = {
            userId,
            action,
        };
    }

    return commitMutation<MutationType>(environment, {
        mutation,
        variables: { input },
    });
}
